import { $isTextNode } from 'lexical';
import { BrandColorRef } from 'modules/BrandDefinition';
import * as Constants from 'const';
import { ParagraphType } from 'services/ArtboardConverter/constants';
import { Schemas } from 'services/ArtboardConverter/models';
import { toPx } from 'utils/toPx';
import { CustomListItemNode } from '../../nodes/CustomListItemNode';
import { ArtboardConverterStyles } from '../convertLexicalEditorState';
import { getParagraphAlign, getParagraphAnchor, getParagraphFontSize, getParagraphLineHeight } from './Paragraph';

type Context = {
  projectType: Constants.ProjectType;
  lineheightNoPx?: boolean;
  depth: number;
  bulletColorRef: BrandColorRef | undefined;
};

export function createParagraphForListItem(
  node: CustomListItemNode,
  context: Context,
  converterStyles: ArtboardConverterStyles,
  segments: Schemas.Segment[],
): Schemas.ListItemParagraph {
  const { depth, bulletColorRef, projectType, lineheightNoPx } = context;

  const firstTextNode = node.getChildren().find($isTextNode);
  const fontSizeNumber = getParagraphFontSize(firstTextNode, converterStyles.fontSize, projectType);
  const { listStyleType, marginLeft } = Constants.Styles.ListItemByDepth[depth];

  return {
    type: ParagraphType.UNORDERED_LIST_ITEM,
    align: getParagraphAlign(node.getFormatType(), converterStyles.paragraphAlign),
    anchor: getParagraphAnchor(node),
    bulletWidth: marginLeft,
    color: bulletColorRef?.HEX ?? converterStyles.bulletColor,
    fontFamily: converterStyles.fontFamily,
    fontSize: toPx(fontSizeNumber),
    lineHeight: getParagraphLineHeight(node.getLineHeight(), fontSizeNumber, converterStyles.lineHeight, lineheightNoPx),
    listStyleType,
    level: depth,
    segments,
  };
}
